import React, { useState, useRef, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas'
import { Accordion, Card, Button, Col, Row, Form, Image } from 'react-bootstrap';
import { ChevronRight, ChevronDown, X, Send, ArrowRight, Info } from 'lucide-react';
import Toaster from '../../Shared/Toaster/Toaster';
import OnBoardSuccessGif from '../../../assets/images/Onboarding-Success-Gif.gif';
import { viewDocument } from '../../../commonservices/CommonMethods';
import callAPI from '../../../commonservices/APIRequests';
import TextBox from "../../Shared/common/components/Shared_FormControls/TextBox/TextBox";
import Attachments from '../../DealerOnboarding/Attachments/Attachments';
import closeIcon from '../../../assets/images/Action-Icons/Circle-Close-Icon.svg'

const NewDigitalSignature = (props) => {

    const currentOnBoardingTabLocal = localStorage.getItem('OnBoardingTab') ? localStorage.getItem('OnBoardingTab') : '';
    const isLender = sessionStorage.getItem('tempDealerId');
    const partnerName = localStorage.getItem('partnerName') ? localStorage.getItem('partnerName') : '';

    const formRef = useRef();
    const signPad = useRef();
    const [activeAccordian, setActiveAccordian] = useState('0');
    const [showImage, setShowImage] = useState(props.digitalSignatureDetails.digitalSignature && props.digitalSignatureDetails.digitalSignature.base64Image ? true : false);
    const [validated, setValidated] = useState(false);
    const [showSignatureError, setShowSignatureError] = useState(false);
    const [toaster, setToaster] = useState({
        header: '',
        class: '',
        content: '',
        showToaster: false
    });
    const [isAcc1Read, setIsAcc1Read] = useState(true);
    const [isAcc2Read, setIsAcc2Read] = useState(currentOnBoardingTabLocal === '7' ? true : false);
    const [isAcc3Read, setIsAcc3Read] = useState(currentOnBoardingTabLocal === '7' ? true : false);

    const toasterClose = () => {

        setToaster({
            header: '',
            class: '',
            content: '',
            showToaster: false
        })

    };

    const bindSignatureState = () => {

        const fileDetails = {
            fileName: 'digitalSignature',
            fileType: 'image/png',
            base64Image: signPad.current.toDataURL()
        }

        props.twoWayBind('digitalSignature', fileDetails);
        setShowSignatureError(false);

    }

    const clearSignature = () => {

        if (signPad.current)
            signPad.current.clear();

        const fileDetails = {
            fileName: '',
            fileType: '',
            base64Image: ''
        }

        if (showImage)
            signaturedeleteDoc(props.digitalSignatureDetails.digitalSignature._id, 'signature')

        props.twoWayBind('digitalSignature', fileDetails);
        setShowImage(false);
        setShowSignatureError(true);

    }

    const signaturedeleteDoc = (docId) => {

        return callAPI.delWithParams('/vehicle/api/v1/dealers/deleteDocument', { documentId: docId })
            .then((response) => {

                if (response.status === 200) {
                }
                else {

                    console.log(response.message);
                }

            })

    }

    const getPaperApp = () => {

        const req = {
            dealerId: props.dealerId,
            type: 'Preview'
        }

        return callAPI.post('/auth/api/v1/dealer/getPreviewDocument', req)
            .then((response) => {
                if (response.status === 200) {
                    if (response.data?.base64)
                        viewDocument('application/pdf', response.data.base64, true)
                }
                else {
                    console.log(response.message);
                }

            })

    }

    const submitForm = (event, isSubmit = false) => {

        event.preventDefault();
        event.stopPropagation();

        setValidated(true);

        if (!props.digitalSignatureDetails.digitalSignature || (props.digitalSignatureDetails.digitalSignature && !props.digitalSignatureDetails.digitalSignature.base64Image)) {

            // setToaster({
            //     header: 'Error',
            //     class: 'error-toaster',
            //     content: 'Please add a Valid Signature',
            //     showToaster: true
            // });
            setShowSignatureError(true);

            return;

        }


        const form = formRef.current;

        if (form.checkValidity() !== false && !showSignatureError)
            props.submit(event, null, false, false, isSubmit);

    }

    const setActiveTab = (tab) => {

        setActiveAccordian(tab);

        if (tab === "0")
            setIsAcc1Read(true);
        if (tab === "1")
            setIsAcc2Read(true);
        if (tab === "2")
            setIsAcc3Read(true);

    }

    const nextHandler = () => {

        if (!isAcc1Read || !isAcc2Read || !isAcc3Read) {

            setToaster({
                header: 'Error',
                class: 'error-toaster',
                content: 'Expand and Read all Sections to Continue.',
                showToaster: true
            });

        }

    }

    useEffect(() => {

        if (!showImage && props.digitalSignatureDetails.digitalSignature && props.digitalSignatureDetails.digitalSignature.base64Image && props.digitalSignatureDetails.digitalSignature.base64Image.indexOf('base64') == -1) {

            setShowImage(true);

        }

    }, [props.digitalSignatureDetails.digitalSignature])

    return (
        <div className='mb-5 signature-page-wrapper'>
            {
                toaster.showToaster ?
                    <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                    : null
            }
            {
                !props.isFormSubmitted || isLender ?
                    <div className='onboarding-form-box-modal mb-4'>
                        <h1>Digital Signature</h1>
                        <div className="OnBoardingComponenet-wrapper digital-signature-block">
                            <div>
                                <Accordion defaultActiveKey="0" onSelect={(tab) => setActiveTab(tab)}>
                                    <Card>
                                        <Card.Header>
                                            <Accordion.Toggle as={Button} variant="link" eventKey="0" className={activeAccordian === '0' ? "content-text-color content-text-14px active-accordion-arrow" : "content-text-color content-text-14px"}>
                                                <span className="primary-text-color accordian-arrow" style={{ outline: !isAcc1Read ? '1px solid #A10F0F' : null }}>{activeAccordian === '0' ? <ChevronDown size={22} /> : <ChevronRight size={22} />}</span>
                                                <b>Terms & Conditions</b>
                                            </Accordion.Toggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="0">
                                            <Card.Body className='content-text-color'>
                                                <p className='mb-3'>By signing and submitting this application, I hereby certify that all of the information is true and accurate, to the best of my knowledge, and authorize {partnerName} to perform all necessary verifications including, but not limited to, business and personal background checks, credit history, bond and insurance verifications, and authorize {partnerName} and its parent company (Vero Technologies) to contact, verify and obtain any information as needed.</p>
                                                <p className='mb-3'>Additionally, Applicant, which term means all persons and entities signing or otherwise authorizing this application, acknowledges and agrees:</p>
                                                <ol className="dealerOnboardDocs p-0 pl-3">
                                                    <li> In addition to the foregoing, the applicant will provide such other information as Vero (which term includes its affiliates and assignees from time time), may request from time to time, including balance sheets, income statements, cash flow reports, and sales reports.</li>

                                                    <li> Applicant represents and warrants that all of the information on this Application and submitted to Vero at any time in any form (i) is correct in all material respects, (ii) does not omit any material facts or information on the subject matter thereof, fairly, and (iii) accurately represents the financial condition of Applicant as of the time it is submitted.</li>

                                                    <li> Applicant will supplement any information submitted if, and promptly after, it becomes aware that any information submitted contained inaccurate or incomplete information.</li>

                                                    <li> Applicant submits this application and all supporting information to induce Vero to extend floorplan financing and/or other credit to the Applicant.</li>

                                                    <li> Applicant acknowledges that Vero will rely on the information it provides for initial and ongoing credit decisions and that such reliance is reasonable.</li>

                                                    <li> Applicant hereby unconditionally authorizes Vero to obtain from and provide to third persons any and all types and kinds of information concerning him, her or it, whether of direct actual experience or obtained from other sources, including, credit history, employment history, and credit reports.  Such authorization continues unless and until there is no debt outstanding from Applicant to Vero and ten days after Applicant revokes this authority.</li>

                                                    <li> Applicant agrees that Vero’s acceptance of this application and any financial information does not constitute an offer, agreement, undertaking, or commitment by Vero to make a floorplan loan or extend any other credit, or to become obligated in any way to Applicant.  While Vero may present a proposal for financing, any such agreement may arise, if at all, under the terms and conditions of definitive credit agreements executed by Vero.</li>

                                                    <li> Applicant agrees that Vero may assign and deliver Applicant’s Application (including Applicant’s authorization and consent to obtain information from credit bureaus and other sources for purposes of prequalification) to affiliated parties and/or Vero’s small business funding network to determine whether Applicant prequalifies for such third-party merchant cash advance services (“Financing”). Applicant also authorizes Vero to transmit and share this Application, along with any information obtained in connection with this Application, excluding consumer credit reports, with any or all of its’ affiliates, subsidiaries, successors, assigns and designees, including third party lenders, service providers, contractors, and partners (“Recipients”). Applicant further authorizes Vero and all Recipients to request, receive, and review any consumer, personal, and business reports and other information about Applicant, including comprehensive credit histories or hard credit pulls (including Applicant’s credit score), credit card processor statements, and bank statements, from one or more consumer reporting agencies, such as TransUnion, Experian, and Equifax, and from other credit bureaus, banks, creditors, and other third parties, for the purpose of obtaining Financing for the Applicant.</li>
                                                </ol>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Card.Header>
                                            <Accordion.Toggle as={Button} variant="link" eventKey="1" className={activeAccordian === '1' ? "content-text-color content-text-14px active-accordion-arrow" : "content-text-color content-text-14px"}>
                                                <span className="primary-text-color accordian-arrow" style={{ outline: !isAcc2Read ? '1px solid #A10F0F' : null }}>{activeAccordian === '1' ? <ChevronDown size={22} /> : <ChevronRight size={22} />}</span>
                                                <b>Equal Credit Opportunity Act</b>
                                            </Accordion.Toggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="1">
                                            <Card.Body className='content-text-color'>
                                                <p>NOTICE:  The federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applicants on the basis of race, color, religion, national origin, sex, marital status, age (provided the applicant has the capacity to enter into a binding contract); because all or part of the applicant’s income derives from any public assistance program; or because the applicant has in good faith exercised any right under the Consumer Credit Protection Act.  The federal agency that administers compliance with this law concerning this creditor is the Federal Trade Commission, Equal Credit Opportunity, Washington, D. C., 20580.</p>
                                                <p>If Vero does not decide to offer financing to Applicant on this Application, Applicant has a right to a written statement of the specific reasons for the decision.  To obtain that statement, Applicant must request the same Vero at the address provided herein within 60 days from the date of notification by Vero of its decision.  Vero will send Applicant a written statement of the reasons for the adverse action within 30 days of receiving Applicant’s request.</p>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Card.Header>
                                            <Accordion.Toggle as={Button} variant="link" eventKey="2" className={activeAccordian === '2' ? "content-text-color content-text-14px active-accordion-arrow" : "content-text-color content-text-14px"}>
                                                <span className="primary-text-color accordian-arrow" style={{ outline: !isAcc3Read ? '1px solid #A10F0F' : null }}>{activeAccordian === '2' ? <ChevronDown size={22} /> : <ChevronRight size={22} />}</span>
                                                <b>USA Patriot Act</b>
                                            </Accordion.Toggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="2">
                                            <Card.Body className='content-text-color'>
                                                <p className='mb-3'>IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT</p>

                                                <p className='mb-3'>To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.</p>

                                                <p className='mb-4'>What this means for Applicant:  When Applicant applies for credit, Vero will ask for Applicant’s name, address, date of birth, and other information that will allow it to identify Applicant.  Vero may also ask to see Applicant’s driver’s license or other identifying documents.</p>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                </Accordion>
                                {
                                    isAcc1Read && isAcc2Read && isAcc3Read ? <div className='accordion'>
                                        <div className='card overflow-visible mb-0'>
                                            <h5 className="btn mb-0">
                                                <span style={{ transform: 'rotate(-180deg)' }}><ChevronDown size={22} /></span>
                                                <b>Digital Signature</b>
                                            </h5>
                                            <div className='card-body'>
                                                <Form className="w3-animate-right digitalSignatureForm"
                                                    noValidate
                                                    validated={validated}
                                                    onSubmit={(event) => submitForm(event)}
                                                    ref={formRef}
                                                >
                                                    <Form.Row className="mx-0 mb-4 two-fields-row">
                                                        <Form.Group as={Col} controlId="formName" className="mb-0">
                                                            <TextBox
                                                                required
                                                                label="Name"
                                                                name="Name"
                                                                value={props.digitalSignatureDetails.name}
                                                                objectKey="name"
                                                                placeholder="Name"
                                                                onChange={(key, value) => props.twoWayBind(key, value)}
                                                            />
                                                            {/* <Form.Label className="label-color single-line-label mb-0">Name</Form.Label>
                                                    <Form.Control
                                                        className='content-text-13px'
                                                        required
                                                        type="text"
                                                        name="Name"
                                                        placeholder="Name"
                                                        value={props.digitalSignatureDetails.name}
                                                        onChange={(event) => props.twoWayBind('name', event.target.value)}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter valid Name.
                                                    </Form.Control.Feedback> */}
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formTitle" className="mb-0">
                                                            <TextBox
                                                                required
                                                                label="Title"
                                                                name="Title"
                                                                value={props.digitalSignatureDetails.title}
                                                                objectKey="title"
                                                                placeholder="Title"
                                                                onChange={(key, value) => props.twoWayBind(key, value)}
                                                            />
                                                            {/* <Form.Label className="label-color single-line-label mb-0">Title</Form.Label>
                                                    <Form.Control
                                                        className='content-text-13px'
                                                        required
                                                        type="text"
                                                        name="Title"
                                                        placeholder="Title"
                                                        value={props.digitalSignatureDetails.title}
                                                        onChange={(event) => props.twoWayBind('title', event.target.value)}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter valid Title.
                                                    </Form.Control.Feedback> */}
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mx-0 digital-signature-filed">
                                                        <Form.Group as={Col} controlId="formPrimaryContactEmail" className='digital-signature-block w-550px mb-0 px-0'>
                                                            <Form.Label className="label-color single-line-label mb-0 display-block">Signature</Form.Label>
                                                            {showImage ? <Image src={props.digitalSignatureDetails.digitalSignature.base64Image}></Image> : <SignatureCanvas penColor='green' ref={signPad}
                                                                canvasProps={{ width: 622, height: 250, className: 'sigCanvas' }} onEnd={bindSignatureState} />}
                                                            <div className='signature-box-btn'>
                                                                {showSignatureError ? <p className='red-status-color'>Please add a Valid Signature</p> : <p className='d-inline'></p>}
                                                                <Button onClick={clearSignature} type="button" variant="primary"><Image src={closeIcon} className='ml-1' size={17} />
                                                                    <span>Clear</span></Button>
                                                            </div>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Row className='w-565px digitalSignActions mx-0'>
                                                        <Col className='flex-grow-0 p-0'>
                                                            <Button id='sign-prev' onClick={(event) => props.submit(event, null, true)} type="button" variant="outline-secondary" className="justify-content-center default-btn"><span>Previous</span></Button>
                                                        </Col>
                                                        <Col className='flex-grow-0 p-0 ml-3'>
                                                            <Button id="sign-prev-pdf" onClick={getPaperApp} type="button" variant="outline-secondary" className='justify-content-center default-btn' ><span>Preview PDF</span></Button>
                                                        </Col>
                                                        <Col className='flex-grow-0 p-0 ml-3'>
                                                            <Button type="button" id='sign-save' onClick={event => submitForm(event)} variant="outline-secondary" className="justify-content-center default-btn"><span>Save</span></Button>
                                                        </Col>
                                                        <Col className='flex-grow-0 p-0 ml-3'>
                                                            <Button id='sign-submit' type="button" onClick={event => submitForm(event, true)} variant="primary" className="justify-content-center default-btn"><span>Submit</span></Button>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </div>
                                        </div>


                                    </div>
                                        : <div>
                                            <div className='accordion'>
                                                <div className='card'>
                                                    <h5 className="btn mb-0">
                                                        <span style={{ transform: 'rotate(90deg)' }}><ChevronRight size={22} /> </span>
                                                        <b>Digital Signature</b></h5>
                                                </div>
                                            </div>
                                            <Button id='sign-prev' onClick={(event) => props.submit(event, null, true)} type="button" variant="outline-secondary" className="default-btn">Previous</Button>
                                            <Button type="button" onClick={nextHandler} variant="primary" className="ml-3 default-btn">Next</Button>
                                        </div>

                                }
                            </div>
                        </div>
                    </div> :
                    <div className='onboarding-form-box-modal'>
                        <h1>Onboarding Success!</h1>
                        <Row className="successMessageAndGif">
                            <Col md={7}>
                                <p className='secondary-text-color mb-3'>Your application is under review.</p>
                                <p className='secondary-text-color mb-3'>The {partnerName} Credit Team is reviewing your application and will follow up if there are any additional documents need to be uploaded.</p>
                                {/* <p className='content-sm-text'><Link>View Submitted Application</Link></p> */}
                                <p className='content-text-14px mb-0'><a onClick={getPaperApp} className='cursor-pointer blue-link-text bold-500'>View Submitted Application</a></p>
                                {/* <p className='content-text-14px'><a href='javascript:void(0)' onClick={() => downloadFile(props.digitalSignatureDetails.onBoardingPdf.base64Image, props.digitalSignatureDetails.onBoardingPdf.fileName)} className='icon-active-color'><Download size={20} /> Download Submitted Application</a></p> */}
                            </Col>
                            {/* <Col md={5} className='text-right'>
                                <Image className='onboardSuccessGiff' src={OnBoardSuccessGif} style={{ maxWidth: '180px' }} fluid />
                            </Col> */}
                        </Row>
                        <Row className='align-items-center mt-2 success-onboarding-attachments'>
                            <Col>
                                <Attachments documentsSectionOnly={true} dealerId={props.dealerId} requestedFacilityAmount={props.requestedFacilityAmount} attachmentsDetails={props.attachmentsDetails} twoWayBind={(key, value, innerStep = null) => props.twoWayBind(key, value, innerStep)} getData={props.getData} />
                            </Col>
                        </Row>
                    </div>

            }
        </div>
    )

}

export default NewDigitalSignature;